import React from "react";

function TestFlightDownload() {
  return (
    <div className="min-h-screen bg-sky-50 py-16 px-6">
      <div className="max-w-5xl mx-auto">


        <section className="space-y-12 text-gray-700">


        <div className="  my-12">
        <img src="/images/lachristmas.png" alt="Christmas Party Invite"  className="max-h-[700px] w-auto mx-auto" />

        </div>

        </section>

        <div className="text-center mt-12">
          <p className="text-gray-500">
           {/*} RSVP: {" "}*/}
            <a 
              href="https://forms.gle/uayxFC8jzL5KdpqV9"
              target="_blank"
              rel="noopener noreferrer"
              className="text-cyan-600 underline">
              RSVP Link
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default TestFlightDownload;
